import { useState } from 'react';
import { List } from 'immutable';
import { useSelector } from 'react-redux';

import useLabelHandlers from './useLabelHandlers';
import useLabelRefresh from './useLabelRefresh';

import { Label } from '../../../../../../../common/labels/labelTypes';
import { selectSelectedElementsNormalisedForTaskLists } from '../../../../selector/selectionToolsSelector';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getFullLabelFetchTimestamp, selectUsableLabels } from '../../../../../../element/labels/labelSelectors';

type ReturnType = {
    allLabels: Label[];
    elements: List<ImMNElement>;
    hasCompletedInitialFetch: boolean;
    searchString: string;
    setSearchString: (value: string) => void;
    handleCreateLabel: () => void;
    handleSearchSubmit: () => void;
    handleToggleLabelSelection: (labelId: string) => void;
};

type Props = {
    currentUserId: string;
    isActive?: boolean;
};

const useLabelsTool = ({ currentUserId, isActive = true }: Props): ReturnType => {
    useLabelRefresh({ isActive });

    const labelMap = useSelector(selectUsableLabels);
    const fullLabelFetchTimestamp = useSelector(getFullLabelFetchTimestamp);
    const allLabels = Object.values(labelMap || {});
    const elements: List<ImMNElement> = useSelector(selectSelectedElementsNormalisedForTaskLists);
    const [searchString, setSearchString] = useState('');
    const hasCompletedInitialFetch = fullLabelFetchTimestamp !== null;

    const { handleToggleLabelSelection, handleCreateLabel, handleSearchSubmit } = useLabelHandlers(
        currentUserId,
        searchString,
        setSearchString,
        elements,
        allLabels,
    );

    return {
        allLabels,
        elements,
        hasCompletedInitialFetch,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    };
};

export default useLabelsTool;
